import { useCallback, useEffect, useReducer, useState } from "react"
import { useConnection, useWallet } from "@solana/wallet-adapter-react"
/* global BigInt */
import { AccountLayout, TOKEN_PROGRAM_ID } from "@solana/spl-token"

import { Metadata } from "@metaplex-foundation/mpl-token-metadata"

import { clusterApiUrl, Connection, PublicKey } from "@solana/web3.js"

import AkumaCardstaking from "./AkumaCardstaking"
//import { useStakedNfts, useRewardNfts } from "../../hooks/useStakedNfts"
import { useNfts } from "../../hooks/useNfts"

import {
	calculateRewards,
	rewardCalculator,
	getRewardCalculator,
	createWithdrawRewardTransaction,
	getStakednfts,
	getAssociatedTokenAddress,
} from "../../utils/staking"

import { Wallet } from "@project-serum/anchor"
import { DataStorage } from "@babylonjs/core"

export default function Stakingcomponent() {
	const { publicKey, signAllTransactions } = useWallet()
	const { connection } = useConnection()
	const [refreshHandle, forceRefresh] = useReducer((x) => !x, true)
	//	const stakedNfts = useStakedNfts(refreshHandle)
	//	const rewardNfts = useRewardNfts(refreshHandle)
	//	const unstakedNfts = useUnstakedNfts(refreshHandle)
	const { myStakedNfts, stakableNfts, PROGRAMS } = useNfts(refreshHandle)

	const [filter, setFilter] = useState("all")
	const [rewardCalculator, setRewardCalculator] = useState(null)

	const [rewardCalculatorA, setRewardCalculatorA] = useState(null)
	const [rewardCalculatorB, setRewardCalculatorB] = useState(null)
	const [rewardCalculatorC, setRewardCalculatorC] = useState(null)
	const [rewardCalculatorD, setRewardCalculatorD] = useState(null)
	const [totalnfts, setTotalnfts] = useState(null)
	//const [myStakedNfts, setMyStakedNfts] = useState([])

	// const [stakedNfts, setStakedNfts] = useState(async (nfts) => {
	// 	const x = nfts.stakedNftuseReducers
	// 	console.log("nfts", x)
	// 	return x
	// })

	const [pendingRewards, setPendingRewards] = useState(() => [])
	const [amount, setAmount] = useState(() => 0)

	const [Rewards, setRewards] = useState(() => [])

	const [rewardMintAmount, setRewardMintAmount] = useState(0)
	const [rewardMintAmounta, setRewardMintAmounta] = useState(0)
	const [rewardMintAmountb, setRewardMintAmountb] = useState(0)
	const [rewardMintAmountc, setRewardMintAmountc] = useState(0)
	const [rewardMintAmountd, setRewardMintAmountd] = useState(0)
	const wallet = useWallet()
	const myStaked = () => {}

	const getMyNftList = async () => {
		let myNftList = []
		await Object.keys(stakedNfts).map(async (x) => {
			const xt = Object.values(await stakedNfts[x].nfts).map((d) =>
				myNftList.push(d)
			)
		})
		await console.log("MYLIST", myNftList)
		await setMyStakedNfts(() => myNftList)
		//return myNftList
	}
	const getStaked = async () => {
		//console.log(PROGRAMS[0].REWARDS)
		if (!PROGRAMS[0]) return

		console.log("THIS IS PROGRAMS", PROGRAMS)

		const a = await PROGRAMS[0].REWARDS.vault.holdings

		const b = await PROGRAMS[1].REWARDS.vault.holdings

		const sum = () => a + b

		console.log("total NFTsTOTAL", await sum())

		console.log("total NFTsTOTAL", await sum())

		return setTotalnfts(() => sum())
	}
	const getRewardsTokens = async () => {
		let accountAddress = await getAssociatedTokenAddress(
			publicKey,
			new PublicKey(PROGRAMS[0].REWARDS.REWARD_MINT.pubkey)
		)
		console.log("MINT: ", accountAddress.toString())

		let value = await connection
			.getTokenAccountBalance(accountAddress, "processed")
			.catch(() => null)

		if (accountAddress && value !== null) {
			return setRewardMintAmount(value.value.uiAmount)
		} else return await setRewardMintAmount(0)
	}
	useEffect(() => {
		// if (!publicKey) return

		// let accountAddress = await getAssociatedTokenAddress(
		// 	publicKey,
		// 	REWARD_MINT
		// )
		// console.log(accountAddress.toString())
		// let { value } = await connection
		// 	.getTokenAccountBalance(accountAddress, "processed")
		// 	.catch(() => null)

		// if (accountAddress) {
		// 	setRewardMintAmount(value.uiAmount)
		// 	console.log(value.uiAmount)
		// } else setRewardMintAmount(0)
		;(async () => {
			//setPendingRewards(0)

			if (!publicKey) return
			//////
			if (!PROGRAMS[0]) return
			//console.log("THIS IS PROGRAMS", PROGRAMS[0])

			setPendingRewards([])
			await getStaked()
			await getRewardsTokens()
		})()
	}, [connection, publicKey, refreshHandle, myStakedNfts])

	// useEffect(() => {
	// 	getStaked()
	// }, [PROGRAMS, refreshHandle, signAllTransactions])
	useEffect(() => {
		console.log(pendingRewards, "changd")

		if (pendingRewards.length > 0) {
			for (var index = 0; index < pendingRewards.length; index++) {
				setAmount(() => {
					return pendingRewards[index].amount
				})
				break
			}
		} else {
			setAmount(() => {
				return 0
			})
		}
	}, [pendingRewards])

	const calculateTotalRewards = useCallback(
		async (now) => {
			console.log("STAKED NFTS", myStakedNfts)
			if (!myStakedNfts) return

			let REWARDTOKENS = []
			let unique = []
			let programtotals = []

			const rewards = await myStakedNfts.map((nft) =>
				calculateRewards(nft, now)
			)

			await PROGRAMS.map((x) => {
				if (!REWARDTOKENS.includes(x.REWARDS.REWARD_MINT.pubkey)) {
					REWARDTOKENS.push(x.REWARDS.REWARD_MINT.pubkey.toLocaleString())
				} else return
			})
			await REWARDTOKENS.map(async (element) => {
				if (!Object.values(unique).includes(element)) {
					await unique.push(element)
				}
			})
			await unique.map(async (x) => {
				const getrewards = await rewards.filter(async (rewarded) => {
					return rewarded.REWARD_MINT.pubkey == x
				})

				const amount = await getrewards
					.map((x) => {
						return x.amount
					})
					.reduce((a, b) => a + b, 0)

				const REWARDDATA = await PROGRAMS.find(
					async (item) => await item.REWARDS.REWARD_MINT.pubkey.includes(x)
				).REWARDS.REWARD_MINT

				await programtotals.push({
					...REWARDDATA,
					amount: amount / 1000000,
				})
			})

			// await console.log("REWARDS TOOOKENS", REWARDTOKENS)
			// await console.log("REWARDS LIST TOOOfsdfasdfadsfasdKENS", unique)
			await console.log("TOTALS", programtotals)
			await setAmount(() => programtotals)
			await setPendingRewards(() => programtotals)
		},
		[connection, calculateTotalRewards, pendingRewards]
	)

	useEffect(() => {
		//setPendingRewards(0)

		if (!myStakedNfts) return

		const interval = 10000
		calculateTotalRewards(new Date())
		let id = setInterval(() => calculateTotalRewards(new Date()), interval)

		return () => clearInterval(id)
	}, [myStakedNfts])

	let filteredNfts = []

	if (filter === "all") filteredNfts = myStakedNfts.concat(stakableNfts)
	else if (filter === "staked") filteredNfts = myStakedNfts
	else if (filter === "unstaked") filteredNfts = stakableNfts
	let collator = new Intl.Collator(undefined, { numeric: true })
	filteredNfts.sort((a, b) => collator.compare(a.data.name, b.data.name))

	const withdrawAllRewards = useCallback(async () => {
		if (!publicKey) return

		try {
			let transactions = await Promise.all(
				myStakedNfts.map((nft) => {
					return createWithdrawRewardTransaction(
						connection,
						publicKey,
						nft.mint,
						nft.pid,
						nft.REWARDS.REWARD_MINT
					)
				})
			)
			let { blockhash } = await connection.getRecentBlockhash("singleGossip")

			transactions.forEach((transaction) => {
				transaction.feePayer = publicKey
				transaction.recentBlockhash = blockhash
			})

			let signedTransactions = await signAllTransactions(transactions)

			let signatures = await Promise.all(
				signedTransactions.map((transaction) =>
					connection.sendRawTransaction(transaction.serialize(), {
						skipPreflight: true,
					})
				)
			)
			await Promise.all(
				signatures.map((signature) =>
					connection.confirmTransaction(signature, "processed")
				)
			)

			//	getRewardCalculatorcalculateTotalRewards(new Date())
			forceRefresh()
		} catch (error) {
			console.error(error)
		}
	}, [connection, publicKey, signAllTransactions])

	return (
		<>
			<div id="main-wrapper-staking">
				<div className="bgtemple"></div>
				<div className="logo">
					<a className="logoimg">
						<img src="img/logo.png"></img>
					</a>
				</div>
				<div className="content">
					<div className="logostaking">
						<img src="img/gify.gif" alt="" />
						<h1 style={{ color: "#FFE003" }}>STAKING</h1>
						<div className="stakingbar">
							{" "}
							<h5>{(totalnfts?.toString() ?? "?") + "/3,444"} DINOS STAKED</h5>
							<div className="bg">
								<div
									className="percentage"
									style={{ width: (totalnfts / 3444) * 100 + "%" }}
								>
									<div className="totalnfts">
										<p>
											{totalnfts == 3444
												? "100%"
												: Math.round((totalnfts / 3444) * 100) + "%"}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{!wallet.connected && (
						<p className="pleaseconnect">PLEASE CONNECT WALLET</p>
					)}
					<div
						className="infowrap"
						style={!wallet.connected ? { display: "none" } : {}}
					>
						<div id="main-info-wrapper">
							<div className="main-info-text-wrapper">
								<p>NFTS OWNED:</p>
								<p>{myStakedNfts?.length + stakableNfts?.length}</p>
							</div>
							<div className="main-info-text-wrapper">
								<p>$MEAT IN WALLET: </p>

								<p>{rewardMintAmount?.toLocaleString() ?? "?"}</p>
							</div>
							<div className="main-info-text-wrapper">
								<p>~ PENDING REWARDS:</p>
								{/* <p>{pendingRewards.amount.toLocaleString() ?? "?"}</p> */}

								<div>
									{/* @ts-ignore */}
									{amount}
									<br />
								</div>
							</div>
							<div className="main-info-text-wrapper">
								<p>MY STAKED NFTS:</p>
								<p>{myStakedNfts.length}</p>
							</div>
						</div>{" "}
						{/* <div id="main-claimhono-button-wrapper">
							<button
								id="main-claimhono-button"
								onClick={() => withdrawAllRewards(``)}
								disabled={myStakedNfts.length === 0}
							>
								CLAIM $MEAT
							</button>
						</div> */}
					</div>
					<div id="main-select-buttons-wrapper">
						<button
							onClick={() => setFilter("all")}
							className={
								"main-select-button" + (filter === "all" ? " selected" : "")
							}
						>
							All
						</button>
						<button
							onClick={() => setFilter("staked")}
							className={
								"main-select-button" + (filter === "staked" ? " selected" : "")
							}
						>
							Staked
						</button>
						<button
							onClick={() => setFilter("unstaked")}
							className={
								"main-select-button" +
								(filter === "unstaked" ? " selected" : "")
							}
						>
							Unstaked
						</button>
					</div>
					<div id="main-cards-wrapper">
						{filteredNfts.map((akuma, index) => (
							<AkumaCardstaking
								key={index}
								nft={akuma}
								onChange={forceRefresh}
								PROGRAMS={PROGRAMS}
							/>
						))}
					</div>
				</div>
			</div>
		</>
	)
}
